/**
 * ParagraphForm: edit form for the `paragraph` block.
 *
 * data: { html }: rich-text HTML.
 *
 * Wraps the TipTap-based RichTextEditor. The editor initializes from the
 * existing `data.html` and emits HTML back into it; the renderer's
 * ParagraphBlock sanitizes that HTML with DOMPurify on display.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import RichTextEditor from '../RichTextEditor';

export default function ParagraphForm({ data, onChange }) {
    const d = data || {};

    return (
        <Form.Group controlId="paragraph-html">
            <Form.Label>Text</Form.Label>
            <RichTextEditor
                html={d.html || ''}
                onChange={(html) => onChange({ ...d, html })}
            />
            <Form.Text muted>
                Use the toolbar for bold, italic, links, and lists.
            </Form.Text>
        </Form.Group>
    );
}

ParagraphForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

ParagraphForm.defaultProps = {
    data: {},
};
